import React, { ReactNode } from 'react';

interface Props {
    content: ReactNode;
}

const HHTooltip: React.FC<Props> = ({ content }) => {

    if (Array.isArray(content)) {
        content = content.map((item, index) => (
            <>
                <p style={{ margin: "10px 0" }} key={index}>{item}</p>
            </>
        ));
    }
    else {
        content = <p>{content}</p>;
    }

    return (
        <div className="tooltip">{content}</div>
    );
};

export default HHTooltip;